










import { Component, Vue } from 'vue-property-decorator';
import ResetPassword from '@/components/auth/ResetPassword.vue';

@Component({
  components: {
    ResetPassword,
  },
})
export default class HomeScreen extends Vue { }
